import type { BlockchainNetwork } from "@/interfaces/blockchainNetwork";
import {
  Activity,
  ArrowDownToLine,
  ArrowUpFromLine,
  Database,
  Layers3,
  Network,
} from "lucide-react";

interface Props {
  networks: BlockchainNetwork[];
}

const BlockchainNetworkStats = ({ networks }: Props) => {
  const total = networks.length;

  const enabled = networks.filter((x) => x.enabled).length;

  const deposits = networks.filter((x) => x.depositEnabled).length;

  const withdrawals = networks.filter((x) => x.withdrawEnabled).length;

  const evm = networks.filter((x) => x.isEvm).length;

  const utxo = networks.filter((x) => x.isUtxo).length;

  const cards = [
    {
      title: "Networks",
      value: total,
      icon: Network,
    },
    {
      title: "Enabled",
      value: enabled,
      icon: Activity,
    },
    {
      title: "Deposits",
      value: deposits,
      icon: ArrowDownToLine,
    },
    {
      title: "Withdrawals",
      value: withdrawals,
      icon: ArrowUpFromLine,
    },
    {
      title: "EVM",
      value: evm,
      icon: Layers3,
    },
    {
      title: "UTXO",
      value: utxo,
      icon: Database,
    },
  ];

  return (
    <div className="grid gap-5 sm:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-6">
      {cards.map((card) => {
        const Icon = card.icon;

        return (
          <div
            key={card.title}
            className="rounded-2xl border bg-card p-5 transition-all hover:shadow-md"
          >
            <div className="flex items-center justify-between">
              <div className="rounded-xl bg-primary/10 p-3">
                <Icon className="h-5 w-5 text-primary" />
              </div>

              <span className="text-3xl font-bold">{card.value}</span>
            </div>

            <p className="mt-5 text-sm font-medium text-muted-foreground">
              {card.title}
            </p>
          </div>
        );
      })}
    </div>
  );
};

export default BlockchainNetworkStats;
